import {
    ICustomFieldsConfig,
    ICustomFieldsConfigCreate,
    ICustomFieldsConfigForm, ICustomFieldsConfigUpdate, ICustomFieldsTableData
} from '../typing/custom-fields-config.interface';

export class CustomFieldsConfig {
    data: ICustomFieldsConfig;

    constructor(data: ICustomFieldsConfig){
        this.data = data;
    }

    dataForCreate(formData: ICustomFieldsConfigForm): ICustomFieldsConfigCreate{
        return {
            label: formData.label,
            type: formData.type,
            projectId: formData.projectId || null,
            required: formData.required,
            customId: formData.customId || null,
        };
    }

    dataForUpdate(formData: ICustomFieldsConfigForm): ICustomFieldsConfigUpdate {
        return {
            id: this.data.id,
            label: formData.label,
            type: formData.type,
            projectId: formData.projectId,
            required: formData.required,
            customId: formData.customId || null,
        };
    }

    formData(): ICustomFieldsConfigForm {
        return {
            label: this.data.label,
            type: this.data.type,
            projectId: this.data.project?.id || null,
            required: this.data.required,
            customId: this.data.customId,
        };
    }

    tableData(): ICustomFieldsTableData {
        return {...this.data, projectName: this.data.project.name};
    }
}
